{
  "fr": {
    "baseBtn": {
      "labels": {
        "loading": "Veuillez patienter..."
      }
    }
  }
}
